// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropDownBalance_button__oyT5l {
    color: #ffffff;
    background-color: #293069;
    padding: 8px 16px;
    font-size:15px;

    
    border-radius: 0.5rem;
    display: flex;
    gap:5px;
    cursor: pointer;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
}
.DropDownBalance_blockBalanceInfo__emztu{
    position: absolute;
    top:40px;
    left:-20px;
    background-color: #001529;
    min-width: 200px;
    font-size: 15px;
    font-family: Popins,sans-serif;
    display: flex;
    gap:10px;
    flex-direction: column;
    border-radius: 10px;
    transform: translateY(-10px);  
    opacity: 0;  
    transition: opacity 0.3s ease, transform 0.3s ease;
    pointer-events: none; /* %D0%9E%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B0%D0%B5%D0%BC %D0%BA%D0%BB%D0%B8%D0%BA%D0%B8 */
}
.DropDownBalance_wrapper__dF3NT{
    display: flex;
    background-color: #293069;
    padding: 10px 5px 10px 5px;
    flex-direction: column;
    gap:5px;
    border-bottom: 1px solid #00152981;

}
.DropDownBalance_active__Whhr0{
    opacity: 1;
    pointer-events: auto; /* %D0%92%D0%BA%D0%BB%D1%8E%D1%87%D0%B0%D0%B5%D0%BC %D0%BA%D0%BB%D0%B8%D0%BA%D0%B8 */
    transform: translateY(0px);
}
.DropDownBalance_header__varzn{
    color:grey;

}
.DropDownBalance_main__EdgXv{
    color:white;
    font-size: 18px;
}
@media screen and (max-width: 1000px){
    .DropDownBalance_button__oyT5l{
        margin-left: 5px;
        font-size:15px;
        font-weight: 400;
        padding: 0.8rem 0.7rem;
        border-radius: 0;
        border-top-left-radius: 10px;
    border-end-start-radius: 10px;


    }

}`, "",{"version":3,"sources":["webpack://./src/components/UI/DropDownBalance/DropDownBalance.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;;;IAGd,qBAAqB;IACrB,aAAa;IACb,OAAO;IACP,eAAe;IACf,kMAAkM;AACtM;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,aAAa;IACb,QAAQ;IACR,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;IAC5B,UAAU;IACV,kDAAkD;IAClD,oBAAoB,EAAE,0FAA0F;AACpH;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;IACtB,OAAO;IACP,kCAAkC;;AAEtC;AACA;IACI,UAAU;IACV,oBAAoB,EAAE,oFAAoF;IAC1G,0BAA0B;AAC9B;AACA;IACI,UAAU;;AAEd;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;QAChB,4BAA4B;IAChC,6BAA6B;;;IAG7B;;AAEJ","sourcesContent":[".button {\n    color: #ffffff;\n    background-color: #293069;\n    padding: 8px 16px;\n    font-size:15px;\n\n    \n    border-radius: 0.5rem;\n    display: flex;\n    gap:5px;\n    cursor: pointer;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n}\n.blockBalanceInfo{\n    position: absolute;\n    top:40px;\n    left:-20px;\n    background-color: #001529;\n    min-width: 200px;\n    font-size: 15px;\n    font-family: Popins,sans-serif;\n    display: flex;\n    gap:10px;\n    flex-direction: column;\n    border-radius: 10px;\n    transform: translateY(-10px);  \n    opacity: 0;  \n    transition: opacity 0.3s ease, transform 0.3s ease;\n    pointer-events: none; /* %D0%9E%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B0%D0%B5%D0%BC %D0%BA%D0%BB%D0%B8%D0%BA%D0%B8 */\n}\n.wrapper{\n    display: flex;\n    background-color: #293069;\n    padding: 10px 5px 10px 5px;\n    flex-direction: column;\n    gap:5px;\n    border-bottom: 1px solid #00152981;\n\n}\n.active{\n    opacity: 1;\n    pointer-events: auto; /* %D0%92%D0%BA%D0%BB%D1%8E%D1%87%D0%B0%D0%B5%D0%BC %D0%BA%D0%BB%D0%B8%D0%BA%D0%B8 */\n    transform: translateY(0px);\n}\n.header{\n    color:grey;\n\n}\n.main{\n    color:white;\n    font-size: 18px;\n}\n@media screen and (max-width: 1000px){\n    .button{\n        margin-left: 5px;\n        font-size:15px;\n        font-weight: 400;\n        padding: 0.8rem 0.7rem;\n        border-radius: 0;\n        border-top-left-radius: 10px;\n    border-end-start-radius: 10px;\n\n\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `DropDownBalance_button__oyT5l`,
	"blockBalanceInfo": `DropDownBalance_blockBalanceInfo__emztu`,
	"wrapper": `DropDownBalance_wrapper__dF3NT`,
	"active": `DropDownBalance_active__Whhr0`,
	"header": `DropDownBalance_header__varzn`,
	"main": `DropDownBalance_main__EdgXv`
};
export default ___CSS_LOADER_EXPORT___;
